import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAllPermissions } from "../../actions/userActions/permissionsAction";
import SearchInput from "../subComponents/search/SearchInput";
import { SIZE_OF_PAGE } from "../../actions/types";
import DynamicTable from "../reuse_components/DynamicTable";
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import Heading6Regular from "../designSystem/Heading6Regular";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate";

function Permissions() {
  const dispatch = useDispatch();
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [previousQuery, setPreviousQuery] = useState("");
  const [query, setQuery] = useState("");
  const permissionsData = useSelector(
    (state) => state.permissions_reducer.allPermissions
  );
  const totalPages = permissionsData?.totalPages || 0;
  const totalItems = permissionsData?.totalCount || 0;
  const permissions = permissionsData && permissionsData?.result && permissionsData?.result[0]?.permissions || [];
  const isLoading = useSelector((state) => state.permissions_reducer.isAllPermissionsLoading);

  useEffect(() => {
    const body = {
      filter: {
        textSearch: query,
        permissionGroup: [0],
      },
      pageNumber: currentPage,
      pageSize: itemsPerPage,
    };

    if (query !== previousQuery) {
      setCurrentPage(1);
    }

    dispatch(getAllPermissions(body));
    setPreviousQuery(query);
  }, [currentPage, query, previousQuery]);

  const PermissionsData = permissions?.map((permission) => ({
    ...permission,
  }));
  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("description")}`, accessor: "description" },
  ];

  const handleSearchChange = (e) => {
    setQuery(e.target.value);
    setCurrentPage(1);
  };
  const handleItemsPerPageChange = (value) => {
    const body = {
      filter: {
        textSearch: query,
        permissionGroup: [0],
      },
      pageNumber: firstPage,
      pageSize: value,
    };    dispatch(getAllPermissions(body));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  return (
    <>
    <div>
    <LoadingOverlay isVisible={isLoading}/>
      <div className="main-container">
        <div className="content-wrapper">
          <div className="pagination">
            <SearchInput
              placeholder="Search"
              onChange={handleSearchChange}
              value={query}
            />
           <div className="flex-align-center">
           <div className="items-per-page-container">
            <ItemsPerPageSelector
               value={itemsPerPage}
                 onChange={handleItemsPerPageChange}
              />
            </div>
            <CustomPagination
              currentPage={currentPage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              totalPages={totalPages}
              onPageChange={(page) => setCurrentPage(page)}
            />
                    </div>
          </div>
      
        </div>
        <DynamicTable
            data={PermissionsData}
            columns={columns}
            thIcon={thIcon}
            showPagination={totalItems > 0}
            currentPage={currentPage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            totalPages={totalPages}
            onPageChange={(page) => setCurrentPage(page)}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
      </div>
      </div>
    </>
  );
}

export default Permissions;
